import { render, staticRenderFns } from "./readingplayer.vue?vue&type=template&id=5131444b&scoped=true&"
import script from "./readingplayer.vue?vue&type=script&lang=js&"
export * from "./readingplayer.vue?vue&type=script&lang=js&"
import style0 from "./readingplayer.vue?vue&type=style&index=0&id=5131444b&lang=less&scoped=true&"
import style1 from "./readingplayer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5131444b",
  null
  
)

export default component.exports